<div class="container-fluid mt-4 pt-4">
    <div class="row">
        <div class="col-12">
            <h2 class="text-center mb-4">
                <i class="fas fa-cog"></i> CONFIGURACIÓN DEL SISTEMA
            </h2>
        </div>
    </div>

    <div class="row">
        <!-- Tabs verticales a la izquierda -->
        <div class="col-md-3 col-lg-2">
            <div class="list-group" id="list-tab" role="tablist">
                <a class="list-group-item list-group-item-action"
                   [class.active]="selectedTab === 'general'"
                   (click)="selectTab('general')"
                   role="tab">
                    <i class="fas fa-info-circle"></i> General
                </a>
                <a class="list-group-item list-group-item-action"
                   [class.active]="selectedTab === 'usuarios'"
                   (click)="selectTab('usuarios')"
                   role="tab">
                    <i class="fas fa-users"></i> Usuarios
                </a>
                <a class="list-group-item list-group-item-action"
                   [class.active]="selectedTab === 'porcentajes'"
                   (click)="selectTab('porcentajes')"
                   role="tab">
                    <i class="fas fa-percent"></i> Porcentajes
                </a>
                <a class="list-group-item list-group-item-action"
                   [class.active]="selectedTab === 'vencimientos'"
                   (click)="selectTab('vencimientos')"
                   role="tab">
                    <i class="fas fa-calendar"></i> Vencimientos
                </a>
                <a class="list-group-item list-group-item-action"
                   [class.active]="selectedTab === 'texto-legal'"
                   (click)="selectTab('texto-legal')"
                   role="tab">
                    <i class="fas fa-file-contract"></i> Texto Legal
                </a>
            </div>
        </div>

        <!-- Contenido a la derecha -->
        <div class="col-md-9 col-lg-10">
            <div class="tab-content" id="nav-tabContent">

                <!-- Tab General -->
                <div *ngIf="selectedTab === 'general'" class="tab-pane fade show active">
                    <div class="card">
                        <div class="card-header bg-primary text-white">
                            <h5><i class="fas fa-info-circle"></i> Información General</h5>
                        </div>
                        <div class="card-body">
                            <p>Configuraciones generales del sistema.</p>
                            <p class="text-muted">Próximamente disponible...</p>
                        </div>
                    </div>
                </div>

                <!-- Tab Usuarios -->
                <div *ngIf="selectedTab === 'usuarios'" class="tab-pane fade show active">
                    <div class="card">
                        <div class="card-header bg-success text-white">
                            <h5><i class="fas fa-users"></i> Gestión de Usuarios</h5>
                        </div>
                        <div class="card-body">
                            <p>Administración de usuarios del sistema.</p>
                            <p class="text-muted">Próximamente disponible...</p>
                        </div>
                    </div>
                </div>

                <!-- Tab Porcentajes -->
                <div *ngIf="selectedTab === 'porcentajes'" class="tab-pane fade show active">
                    <app-porcentajes></app-porcentajes>
                </div>

                <!-- Tab Vencimientos -->
                <div *ngIf="selectedTab === 'vencimientos'" class="tab-pane fade show active">
                    <app-vencimientos></app-vencimientos>
                </div>

                <!-- Tab Texto Legal -->
                <div *ngIf="selectedTab === 'texto-legal'" class="tab-pane fade show active">
                    <app-texto-legal></app-texto-legal>
                </div>

            </div>
        </div>
    </div>
</div>
